export default function Hero() {
  return (
    <section id="headline" className="pt-4 md:pt-8">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* thin edition label */}
        <div className="flex items-center gap-3 text-foreground-500 font-label">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700 border border-primary-200/70">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-primary-600" />
            </span>
            今日 · 置顶瓜
          </span>
          <span className="text-xs tracking-[0.2em]">2026年9月6日 头版</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {/* copy-first column */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h2 className="font-serif text-4xl leading-[1.15] font-black text-foreground-950 text-balance md:text-[54px] md:leading-[1.12]">
              深夜会所外闪光灯连成一片，
              <br />
              当红顶流被拍后
              <span className="relative inline-block px-1 text-primary-600">
                三小时未回线
                <span className="absolute -bottom-1 left-0 right-0 h-[6px] bg-primary-100 rounded" />
              </span>
            </h2>

            <p className="mt-7 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              本台蹲点记者在凌晨曝出第一手画面：同行两位艺人先后下车、刻意错峰，经纪人隔空对词口径一致。是真的约饭，还是又一次"避嫌式营业"？知情人给出了一个谁都没料到的说法。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-2 text-xs text-foreground-500 font-label">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-accent-900">
                <i className="ri-star-smile-fill text-sm w-4 h-4 flex items-center justify-center" />
                独家 · 首发
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-200/70 px-3 py-1 text-foreground-600">
                <i className="ri-user-star-line text-sm w-4 h-4 flex items-center justify-center" />
                蹲点记者 · 老瓜
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-200/70 px-3 py-1 text-foreground-600">
                <i className="ri-time-line text-sm w-4 h-4 flex items-center justify-center" />
                22 分钟前
              </span>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href="#exclusives"
                className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                点开吃这口瓜
                <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
              </a>
              <span className="inline-flex items-center gap-2 text-sm text-foreground-500 font-label cursor-pointer">
                <i className="ri-chat-smile-3-line text-lg w-5 h-5 flex items-center justify-center" />
                已有 2.3w 人吃到这儿了
              </span>
            </div>
          </div>

          {/* cover companion column */}
          <div className="lg:col-span-5">
            <figure className="relative overflow-hidden rounded-lg border border-background-300/60">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20editorial%20magazine%20cover%20of%20a%20shadowy%20celebrity%20silhouette%20walking%20past%20a%20wall%20of%20paparazzi%20camera%20flashes%20at%20night%2C%20backlit%20with%20warm%20amber%20and%20deep%20vermillion%20red%20rim%20lighting%2C%20dark%20moody%20background%20with%20soft%20bokeh%20light%20specks%2C%20grainy%20analog%20film%20texture%2C%20high%20contrast%20dramatic%20editorial%20photography%2C%20elegant%20intriguing%20magazine%20aesthetic&width=820&height=1040&seq=5gua-hero-cover&orientation=portrait"
                alt="深夜街头被镜头包围的身影"
                title="5吃瓜网独家首拍 · 顶流夜归画面"
                className="h-[440px] w-full object-cover md:h-[520px] lg:h-[560px]"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 text-background-50">
                <p className="text-[11px] tracking-[0.25em] font-label">5吃瓜网 · 第一现场</p>
                <p className="mt-1 text-sm font-medium text-background-50/95">蹲点第 3 晚，终于等到这人。</p>
              </figcaption>
            </figure>
            <p className="mt-2 text-center text-[11px] text-foreground-400 font-label">封面速记 · 画面经技术处理，仅为示意</p>
          </div>
        </div>
      </div>
    </section>
  );
}